import { gql } from "@apollo/client"

/**
 * Trae los torneos activos/recientes del jugador de la sesión, con solo su
 * propio match por ronda (no todas las mesas de la ronda) — resuelto
 * server-side por ActiveTournamentsWithMyRounds para no traer más datos de
 * los que la sección realmente usa.
 */
export const GET_ACTIVE_TOURNAMENTS_WITH_ROUNDS = gql`
  query ActiveTournamentsWithMyRounds($input: ActiveTournamentsWithRoundsInput) {
    ActiveTournamentsWithMyRounds(input: $input) {
      status {
        success
        name
        detail
      }
      Tournaments {
        id
        name
        urlView
        statusId
        startDate
        Store {
          name
        }
        Game {
          name
          urlImage
        }
        TournamentType {
          urlImage
          urlImage2
          urlImage3
          urlImage4
        }
        TournamentRounds {
          id
          name
          created
          sortOrder
          statusId
          urlView
          Match {
            id
            table
            reported
            modified
            draw
            playerId
            opponentId
            winnerId
            winnerVictories
            loserVictories
            ModifiedBy {
              id
              fullName
            }
            Player {
              id
              drop
              Person {
                id
                fullName
                code
                urlAvatar
                avatar
              }
            }
            Opponent {
              id
              drop
              Person {
                id
                fullName
                code
                urlAvatar
                avatar
              }
            }
          }
        }
      }
    }
  }
`
